import {CSSProperties, FC} from 'react';


export interface IIconEspBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconEspBmw: FC<IIconEspBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M17.808 8.333H20l-1.447-1.377 1.009-.312c.394-.133.438-.266.438-.533s-.175-.444-.526-.444h-1.227C17.107 3.889 16.493 3 14.652 3H9.567c-1.841 0-2.455.889-3.594 2.667H4.745c-.35 0-.526.133-.526.4 0 .266.044.444.439.577L5.666 7 4.219 8.333h2.192c.964 0 1.753.445 1.753 1.778H4v3.822C4 14.423 4.614 15 5.096 15H6.41c.482 0 .657-.578.657-1.067v-.266h9.644v.266c0 .49.614 1.067 1.096 1.067h1.315c.482 0 .658-.578.658-1.067v-3.822h-3.726c0-1.333.789-1.778 1.753-1.778ZM6.85 6.556c.483-1.778 1.096-2.667 2.455-2.667h5.611c1.359 0 1.973.889 2.455 2.667H6.85ZM7.756 16.156c.162.255.244.52.244.797 0 .873-.804 1.442-1.514 1.945-.299.212-.581.412-.778.61a.414.414 0 0 0-.012.58c.138.146.36.335.705.517.338.178.682.314.906.395H4.805c-.369-.366-.555-.759-.555-1.176 0-.873.804-1.443 1.514-1.946.299-.212.581-.412.778-.609l.006-.006a.414.414 0 0 0 .005-.574 2.687 2.687 0 0 0-.719-.527l-.01-.006h1.932Zm9.75 0c.162.255.244.52.244.797 0 .873-.804 1.442-1.514 1.945-.299.212-.581.412-.778.61a.414.414 0 0 0-.012.58c.138.146.36.335.705.517.338.178.682.314.906.395h-2.502c-.369-.366-.555-.759-.555-1.176 0-.873.804-1.443 1.514-1.946.299-.212.581-.412.778-.609l.006-.006a.415.415 0 0 0 .005-.574 2.687 2.687 0 0 0-.719-.527l-.01-.006h1.932Z" />
        </svg>
    );
};
